import React, { useState, FormEvent } from 'react';

interface SearchBarProps {
  onSearch: (query: string, sort?: string) => void;
  isLoading: boolean;
}

/** 검색어 입력 및 정렬 옵션 선택 컴포넌트 */
export default function SearchBar({ onSearch, isLoading }: SearchBarProps) {
  const [query, setQuery] = useState('');
  const [sort, setSort] = useState('sim');

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    onSearch(query, sort);
  };

  return (
    <form onSubmit={handleSubmit} className="search-bar">
      <div className="search-input-group">
        <label htmlFor="search-input" className="sr-only">
          상품 검색
        </label>
        <input
          id="search-input"
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="찾고 싶은 상품을 입력하세요"
          disabled={isLoading}
          autoComplete="off"
        />
        <label htmlFor="sort-select" className="sr-only">
          정렬 기준
        </label>
        <select
          id="sort-select"
          value={sort}
          onChange={(e) => setSort(e.target.value)}
          disabled={isLoading}
        >
          <option value="sim">정확도순</option>
          <option value="asc">낮은가격순</option>
          <option value="dsc">높은가격순</option>
          <option value="date">최신순</option>
        </select>
        <button type="submit" disabled={isLoading || !query.trim()}>
          {isLoading ? '검색 중...' : '검색'}
        </button>
      </div>
    </form>
  );
}
